class Route {
    constructor() {
        this.Storage    = new App.Interface.Storage('route');

        /* Globalize Requests */
        App.Route = route => this.retrieve(route);
    }

    get url() {
        return App.Variable('Interface.Route');
    }

    get(key) {
        let route = App.Data.getRoute(key) || this.Storage.get(key);
        if (!route) {
            /* Make the AJAX-call. */
            route = $.ajax({
                url:        this.url + key,
                async:      false,
                dataType:   'html',
            }).done(response => response);

            this.Storage.set(key, route.responseText);
            route = this.Storage.get(key);
        }
        return route;
    }

    set(key, route) {
        this.Storage.set(key, route);
    }

    retrieve(key) {
        return App.Interface.Route.get(key);
    }
}
App.Interface.Route = new Route();
